import React, { useState, useRef, useEffect } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import "./ChatItem.css";
import { CircularProgress, TextField } from "@mui/material";

const ChatItem = ({ chat, selectedChatId, onChatSelect, onRename, onDelete }) => {
    const [isHover, setIsHover] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [newChatName, setNewChatName] = useState(chat.chatName);
    const [isLoading, setIsLoading] = useState(false);
    const menu = useRef(null);
    const inputRef = useRef(null);

    const handleRenameSubmit = async () => {
        if (newChatName.trim() !== chat.chatName) {
            setIsLoading(true);
            await onRename(chat.chatId, newChatName.trim(), true);
            setIsLoading(false);
        }
        setIsEditing(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isEditing && inputRef.current && !inputRef.current.contains(event.target)) {
                handleRenameSubmit();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isEditing, newChatName]);

    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);
    const handleRenameClick = () => setIsEditing(true);

    const handleDeleteClick = async () => {
        setIsLoading(true);
        await onDelete(chat.chatId);
        setIsLoading(false);
    };

    const items = [
        { label: 'Rename', icon: 'pi pi-pencil', command: handleRenameClick },
        { label: 'Delete', icon: 'pi pi-trash', command: handleDeleteClick }
    ];

    

    return (
        <div
            className={`old-chat p-shadow-2 ${selectedChatId === chat.chatId ? 'selected-chat' : ''} ${isLoading ? 'loading' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={() => onChatSelect(chat)}
            onDoubleClick={handleRenameClick}
            style={{ position: 'relative' }}
        >
            <div className="chat-content">
                {/* <i className="pi pi-comment chat-icon"></i> */}
                {isEditing ? (
                    <TextField
                        ref={inputRef}
                        value={newChatName}
                        onChange={(e) => setNewChatName(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleRenameSubmit()}
                        className="rename-input"
                        autoFocus
                    />
                ) : (
                    <span className="chat-name" title={chat.chatName}>{chat.chatName}</span>
                )}
            </div>
            {isLoading && (
                <div>
                    <CircularProgress size={20} />
                </div>
            )}
            {isHover && !isEditing && (
                <div className="chat-options" onClick={(e) => e.stopPropagation()}>
                    <Button icon="pi pi-ellipsis-h" className="p-button-text" onClick={(e) => menu.current.toggle(e)} />
                    <Menu model={items} popup ref={menu} />
                </div>
            )}
        </div>
    );
};

export default ChatItem;
